// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c55d4105763b15850c86c04fb23f8c5fd313a481/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};